import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { MilestoneInfo } from "../GQLCalls/getMilestonesCall";

export type MilestoneItem = DynamicDataObk<MilestoneInfo[]>

const milestonesDataAdapter = createEntityAdapter({
  selectId: (item: MilestoneItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<MilestoneItem, string>, {con, data}: MilestoneItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "milestone_id")
    data.forEach((entry) => dataDictionary[entry.milestone_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      milestonesDataAdapter.upsertOne(state, newPayload);
    }
  } else { milestonesDataAdapter.addOne(state, {con, data})}
}

const milestonesSlice = createSlice({
  name: "milestones",
    initialState: milestonesDataAdapter.getInitialState(),
      reducers: {
        maintained: (state, {payload}:PayloadAction<MilestoneItem>) => {
          mergePayloadAndState(state, payload);
        }
    }
})

export const MilestoneActions = milestonesSlice.actions;
export default milestonesSlice.reducer;